import { render, staticRenderFns } from "./ClientRereferralModal.vue?vue&type=template&id=5af8e73a&scoped=true&"
import script from "./ClientRereferralModal.vue?vue&type=script&lang=js&"
export * from "./ClientRereferralModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8e73a",
  null
  
)

export default component.exports